<span *ngIf="fiscal_id?.value">
  <b *ngIf="showLabel && fiscal_id.label">{{ fiscal_id.label }}: </b>
  <samp class="truncate">{{ fiscal_id.mask ? (fiscal_id.value| mask: fiscal_id.mask) : fiscal_id.value }}</samp>
</span>